import React from 'react';

type Props = {
  title: string;
  content?: string;
};

const Block: React.FC<Props> = ({ title, content }) => {
  return (
    <div className='flex flex-col gap-1'>
      <h2 className='text-muted-foreground font-normal text-[16px]'>
        {title}:
      </h2>
      <p className='truncate font-normal text-[16px]'>
        {content ? content : '-'}
      </p>
    </div>
  );
};

export default Block;
